// extracted by mini-css-extract-plugin
export default {"reactTooltipStyle":"TagTooltip_reactTooltipStyle__ZDUwl","tag":"TagTooltip_tag__LRSlc"};